<form [formGroup]="dadProductForm" class="popup-form">

  <div class="popup-body">

    <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <div class="field-group">
      <label for="market">Market</label>
      <p-dropdown [options]="marketsList" [style]="{width: '100%'}"
                  formControlName="market" id="market"
                  placeholder="Select a market"></p-dropdown>
    </div>

    <div class="field-row">
      <div class="field-group">
        <label for="productType">Product type</label>
        <p-dropdown [options]="productTypesList" [style]="{width: '100%'}"
                    formControlName="productType" id="productType"
                    placeholder="Select a type"></p-dropdown>
      </div>

      <div class="field-group">
        <label for="rebillingProductType">Rebilling type</label>
        <p-dropdown [options]="rebillingProductTypesList" [style]="{width: '100%'}"
                    formControlName="rebillingProductType" id="rebillingProductType"
                    placeholder="Select a rebilling type" appendTo="body"></p-dropdown>
      </div>
    </div>

    <div class="field-row">
      <div class="field-group">
        <label for="productCode">Product code</label>
        <input class="form-control" formControlName="productCode" id="productCode"
               placeholder="e.g. NYSE123" type="text">
        <span class="field-error"
              *ngIf="dadProductForm.get('productCode').touched && dadProductForm.get('productCode').errors">
          Required.
        </span>
      </div>

      <div class="field-group">
        <label for="internalProductCode">Internal product code</label>
        <input class="form-control" formControlName="internalProductCode" id="internalProductCode"
               placeholder="e.g. ICE-REBIL-USVCDF" type="text">
        <span class="field-error"
              *ngIf="dadProductForm.get('internalProductCode').touched && dadProductForm.get('internalProductCode').errors">
          Required.
        </span>
      </div>
    </div>

    <div class="field-row">
      <div class="field-group">
        <label for="startDate">Valid from</label>
        <p-calendar dateFormat="dd/mm/yy" formControlName="startDate" id="startDate"
                    [style]="{width: '100%'}" appendTo="body"
                    panelStyleClass="sym-datepicker sym-datepicker-sm"></p-calendar>
      </div>

      <div class="field-group">
        <label for="rebillingColor">Report color</label>
        <input class="form-control" formControlName="rebillingColor" id="rebillingColor" type="color">
      </div>
    </div>

  </div>

  <div class="popup-footer">
    <button (click)="onSubmit()" class="btn btn-primary" [disabled]="dadProductForm.invalid">
      <ng-container *ngIf="!isEditDadProduct">
        <i class="fa fa-plus-circle"></i> Add Product
      </ng-container>
      <ng-container *ngIf="isEditDadProduct">
        <i class="fa fa-check"></i> Save Changes
      </ng-container>
    </button>
  </div>

</form>
